import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AppSettingsService {
  public environment = {
    hostPath: "",
    basePath: "",
    lcode: "",
    baseAppPath: "",
    imagePath: "",
    imagePathForProduct: "",
    orgLogoPath: "",
    insurorgLogoPath: "",
    encrypt: false,
    maxDropDownFileSize: 0,
    maxFileUploadFileSize: 0,
    fileSizeErrorMsgForDropZone: "",
    fileSizeErrorMsgForFileUpload: '',
    fileAccept: "",
    serverDateFormat: "",
    serverDateFormatWithTime: "",
    dateViewFormat: "",
    utcTime: false,
    dateViewFormatWithTime: "",
    region: "global",
    insuranceUrl: '',
    insuranceClientCode: [],
    admin_entityPath:"",
    getInsurmet: false
  };

  constructor(private http: HttpClient) { }

  loadConfig() {
    let d = new Date();
    let n = d.getTime();
    return this.http
      .get("./app.settings.json?v=" + n)
      .toPromise()
      .then((success: any) => {
        this.environment = success;
        document.body.classList.add(this.environment.region);
      });
  }
}
